import React from 'react'
import Edit from '../crud/edit'
import menuItems from './menuItems'

const fields = [
  {
    name: 'Session Expiration in Hours',
    prop: 'value',
    type: 'text'
  }
]

const EditSettings = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Session Expiration in Hours'
      fields={fields}
      apiPath='admin/settings/session_expiration_in_hours'
      successRedirectPath='/settings'
      buildMenuItems={menuItems}
      disableDelete
    />
  )
}

export default EditSettings
